import React from 'react';
import '../_footer.scss';

import { injectIntl, intlShape } from '@edx/frontend-platform/i18n';
import { sendTrackEvent } from '@edx/frontend-platform/analytics';
import { ensureConfig } from '@edx/frontend-platform/config';
import { AppContext } from '@edx/frontend-platform/react';

import { getConfig } from '@edx/frontend-platform';
import NewsSubscriptionForm from './news-subscription-form';
import messages from './Footer.messages';

import tgLogo from '../assets/images/tg.png';
import vkLogo from '../assets/images/vk.png';
import maxLogo from '../assets/images/max.svg';
import eduLogoSmall from '../assets/images/openedu-logo-sm.png';
import edxLogo from '../assets/images/openedx-logo.png';

import ImgNavigationBar from './img-navigation-bar';
import NavigationMenu from './navigation-menu';
import LocaleToggle from './locale-toggle/locale-toggle';

ensureConfig([
  'LOGO_TRADEMARK_URL',
], 'Footer component');

const EVENT_NAMES = {
  FOOTER_LINK: 'edx.bi.footer.link',
};

ensureConfig([
  'SSO_SWITCH_LOCALE_URL',
  'TELEGRAM_URL',
  'VK_URL',
  'MAX_URL',
  'PLP_BASE_URL',
  'COURSES_URL',
  'PROGRAMS_URL',
  'SPECIALIZE_URL',
  'PARTNERSHIP_URL',
  'TERMS_URL',
  'CONTACTS_URL',
  'FOR_MEDIA_URL',
  'PDPOLICY_URL',
  'CATALOG_URL',
  'FEEDBACK_URL',
  'REQUIREMENTS_URL',
  'MY_COURSES_URL',
  'MY_PROGRAMS_URL',
  'FAQ_URL',
  'ACCOUNT_URL',
  'ABOUT_URL',
  'NEWS_SUBSCRIPTION_URL',
], 'SiteFooter additional config');

class SiteFooter extends React.Component {
  constructor(props) {
    super(props);
    this.externalLinkClickHandler = this.externalLinkClickHandler.bind(this);
  }

  getLocalePrefix(locale) {
    const twoLetterPrefix = locale.substring(0, 2).toLowerCase();
    if (twoLetterPrefix === 'en') {
      return '';
    }
    return `/${twoLetterPrefix}`;
  }

  externalLinkClickHandler(event) {
    const label = event.currentTarget.getAttribute('href');
    const eventName = EVENT_NAMES.FOOTER_LINK;
    const properties = {
      category: 'outbound_link',
      label,
    };
    sendTrackEvent(eventName, properties);
  }

  // eslint-disable-next-line react/sort-comp
  socialNetworksList = [
    { href: getConfig().TELEGRAM_URL, img: tgLogo },
    { href: getConfig().VK_URL, img: vkLogo },
    { href: getConfig().MAX_URL, img: maxLogo },
  ];

  firstColList = [
    {
      href: getConfig().CATALOG_URL,
      label: this.props.intl.formatMessage(messages['footer.links.coursesCatalog']),
    },
    {
      href: getConfig().PROGRAMS_URL,
      label: this.props.intl.formatMessage(messages['footer.links.programsCatalog']),
    },
    {
      href: getConfig().SPECIALIZE_URL,
      label: this.props.intl.formatMessage(messages['footer.links.educationDirections']),
    },
  ];

  secondColList = [
    {
      href: getConfig().ABOUT_URL,
      label: this.props.intl.formatMessage(messages['footer.links.about']),
    },
    {
      href: getConfig().FAQ_URL,
      label: this.props.intl.formatMessage(messages['footer.links.faq']),
    },
    {
      href: getConfig().FEEDBACK_URL,
      label: this.props.intl.formatMessage(messages['footer.links.feedback']),
    },
    {
      href: getConfig().REQUIREMENTS_URL,
      label: this.props.intl.formatMessage(messages['footer.links.requirements']),
    },
  ];

  thirdColList = [
    {
      href: getConfig().TERMS_URL,
      label: this.props.intl.formatMessage(messages['footer.links.terms']),
    },
    {
      href: getConfig().CONTACTS_URL,
      label: this.props.intl.formatMessage(messages['footer.links.contacts']),
    },
    {
      href: getConfig().FOR_MEDIA_URL,
      label: this.props.intl.formatMessage(messages['footer.links.forMedia']),
    },
    {
      href: getConfig().PDPOLICY_URL,
      label: this.props.intl.formatMessage(messages['footer.links.policy']),
    },
  ];

  render() {
    const {
      intl,
    } = this.props;

    return (
      <footer className="footer">
        <div className="footer__container">
          <div className="footer__section">
            <div className="footer__logo-with-primary-links footer__subsection">
              <a className="footer__logo" href={getConfig().PLP_BASE_URL}>
                <img alt={getConfig().SITE_NAME} src={eduLogoSmall} />
              </a>
              <NavigationMenu
                isPrimary
                items={this.firstColList}
                className="nav-list-container__nav-list left-list-block"
              />
            </div>
            <div className="footer__secondary-links footer__subsection footer__subsection--fixed-width">
              <NavigationMenu
                className="footer__secondary-nav"
                items={this.secondColList}
              />
              <NavigationMenu
                className="footer__secondary-nav"
                items={this.thirdColList}
              />
            </div>
          </div>
          <div className="footer__edx-logo-with-locale footer__section">
            <a className="footer__edx-logo" href="http://openedx.org/">
              <img alt="Open edX" src={edxLogo} width={150} height={50} />
            </a>
            <div className="lang-icon-block">
              <LocaleToggle className="footer-lang-block" />
            </div>
          </div>
          <div className="footer__section">
            <NewsSubscriptionForm className="footer__news-sub-form footer__subsection footer__subsection--fixed-width" />
            <div className="footer__copyright-with-social">
              <span className="footer__copyright">
                © {new Date().getFullYear()}
                {' '}
                {intl.formatMessage(messages['footer.labels.copyright'])}
              </span>
              <ImgNavigationBar
                items={this.socialNetworksList}
                className="nav-list-container__img-nav-list"
              />
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

SiteFooter.contextType = AppContext;

SiteFooter.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(SiteFooter);
export { EVENT_NAMES };
